import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Oracle } from '@switchboard-xyz/on-demand';

export default class OracleSetOperator extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Set the NCN operator account for the oracle';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    operator: Flags.string({
      description: 'The jito ncn operator to attach to the oracle',
      required: true,
    }),
  };

  static args = {
    oracle: Args.string({
      description: 'The oracle account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof OracleSetOperator
    );

    const program = await this.program;

    const oracle = new Oracle(program, new web3.PublicKey(args.oracle!));
    const operator = new web3.PublicKey(flags.operator);
    const ix = await oracle.setOperatorIx({ operator });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to set the operator for the oracle account');
  }
}
